import 'css-chunk:src/applications/ProductFulfillmentApp/NoCatalogueProductSelection/components/OrderTable/OrderTable.scss';export default {
  "OrderReview": "_OrderReview_1t1l5_1",
  "avatar": "_avatar_1t1l5_16",
  "mainContentWrapper": "_mainContentWrapper_1t1l5_20",
  "footer": "_footer_1t1l5_24",
  "footerButton": "_footerButton_1t1l5_32",
  "nameCell": "_nameCell_1t1l5_35",
  "name": "_name_1t1l5_35"
};